








































import { computed, defineComponent, ref } from '@vue/composition-api';
import { Feature, FeatureCollection } from 'geojson';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { Field, Sample, Sampling, SamplingCollection } from '@/store/types';
import { prepareSamplingCollectionForSubmission } from './helpers';

export default defineComponent({
	components: { ConfirmDialog },
	props: {
		locations: {
			type: Object as () => FeatureCollection,
			required: true,
		},
		field: {
			type: Object as () => Field,
			required: true,
		},
		samplingCollection: {
			type: Object as () => SamplingCollection,
			required: true,
		},
		samplings: {
			type: Array as () => Sampling[],
			required: true,
		},
		samples: {
			type: Array as () => Sample[],
			required: true,
		},
	},
	setup(props, { root }) {
		const showSubmitDialog = ref<boolean>(false);
		const progress = computed(() => {
			if (props.locations) {
				const completed = props.locations.features.filter(
					(l: Feature) => l.properties?.markerType !== 'LOCATION_INCOMPLETE'
				).length;
				const total = props.locations.features.length;
				return `${completed} / ${total}`;
			}
		});

		const submitIsLoading = computed(() => root.$store.getters['resources/getSubmitIsLoading']);
		const submitHasError = computed(() => root.$store.getters['resources/getSubmitHasError']);

		const handleSubmit = () => {
			const submittableSamplingCollection = prepareSamplingCollectionForSubmission({
				samplingCollection: props.samplingCollection,
				samplings: props.samplings,
				samples: props.samples,
			});

			root.$store.dispatch('resources/submitSamplingCollection', {
				populatedSamplingCollection: submittableSamplingCollection,
				locationCollectionId: props.samplingCollection.object,
			});
		};

		const handleCleanup = () => root.$store.dispatch('resources/acknowledgeSubmitSamplingCollectionError');

		return {
			showSubmitDialog,
			progress,
			submitIsLoading,
			submitHasError,
			handleSubmit,
			handleCleanup,
		};
	},
});
